import React, { useEffect, useState } from "react";
import { useFetch } from "../../../../../hooks/fetch";
import { getValidForEbvPayersAPI } from "../../../../../api/api";
import { Form, Select } from "antd";
import { SingleSelect } from "../../../../customComponent/CustomSelect";
import { OTHER } from "../../constants";
import { useTranslation } from "react-i18next";

const { Option } = Select;

export const PayerItem = ({
  label,
  required,
  rules = [],
  placeholder,
  allowOther,
  shouldValidateFields = false,
  ...props
}) => {
  const { t } = useTranslation();

  const [fetchValidPayers, validPayersResponse] = useFetch(getValidForEbvPayersAPI);
  const [validPayers, setValidPayers] = useState([]);

  useEffect(() => {
    fetchValidPayers();
  }, []);

  useEffect(() => {
    if (validPayersResponse) {
      setValidPayers(validPayersResponse.data);
    }
  }, [validPayersResponse]);

  return (
    <Form.Item name={props.name} label={label} rules={[{ required }, ...rules]}>
      <SingleSelect
        shouldValidateFields={shouldValidateFields}
        useCommonStyle={false}
        listHeight={200}
        bordered={true}
        allowClear={true}
        placeholder={placeholder}
      >
        {validPayers.map((payer) => (
          <Option key={payer.id} value={payer.name}>
            {payer.name}
          </Option>
        ))}
        {allowOther && (
          <Option key="other" value={OTHER}>
            {t("other")}
          </Option>
        )}
      </SingleSelect>
    </Form.Item>
  );
};
